var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6908 3.23628C28.4933 3.06168 28.2316 2.97783 27.9693 3.00504L11.255 4.8622C10.7846 4.91427 10.4286 5.31189 10.4286 5.7852V22.3336C9.58703 21.83 8.62367 21.5664 7.6429 21.5713C5.08281 21.5713 3 23.2372 3 25.2856C3 27.3341 5.08281 29 7.64285 29C10.2029 29 12.2857 27.335 12.2857 25.2856V11.264L27.1429 9.60921V20.4737C26.301 19.9711 25.3377 19.7084 24.3572 19.7141C21.7971 19.7141 19.7143 21.38 19.7143 23.4285C19.7143 25.4769 21.7971 27.1428 24.3572 27.1428C26.9172 27.1428 29 25.4779 29 23.4285V3.92809C29 3.66399 28.8876 3.4124 28.6908 3.23628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.5984039a0c27ee866185f156c1d105e5.svg";
export { ForwardRef as ReactComponent };